import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { apiBaseUrl } from '@/request/index'

interface PrivateRouteProps {
	children: React.ReactNode
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
	const location = useLocation()
	const [checking, setChecking] = useState(!localStorage.getItem('userInfo'))
	const [authed, setAuthed] = useState(!!localStorage.getItem('userInfo'))

	useEffect(() => {
		if (localStorage.getItem('userInfo')) return

		fetch(`${apiBaseUrl}/auth/me`, { credentials: 'include' })
			.then(res => res.ok ? res.json() : null)
			.then(data => {
				if (data && data.user && data.user.email) {
					const info = { name: data.user.email, email: data.user.email, role: data.user.role || 'user' }
					localStorage.setItem('userInfo', JSON.stringify(info))
					window.dispatchEvent(new Event('userInfoChanged'))
					setAuthed(true)
				}
			})
			.catch(() => {})
			.finally(() => setChecking(false))
	}, [location.pathname])

	if (checking) return null
	if (!authed) return <Navigate to="/signin" replace state={{ callbackUrl: location.pathname + location.search }} />

	return <>{children}</>
}

export default PrivateRoute
